import { useQuery } from 'react-query';

import { getActivityMainDetailsByTaskdId as queryFn } from 'api/endPoints/getActivityMainDetailsByTaskdId';

export const useQueryActivityDetailsByTaskdId = (params) => {
    return useQuery<IActivityDetailsResponse, QueryError>(['createUserAction', params], () => queryFn(params), {
        enabled: Boolean(params),
    });
};

export interface IActivityDetailsResponse {
    activityId: number;
    activityName: string;
    wbsId: number;
    wbsName: string;
    versionName: string;
    versionDate: number;
    versionId: number;
    projectId: number;
    projectName: string;
    subProgramId: number;
    subProgramName: string;
}
